import StorefrontMock from "@/components/landing/ResponsiveShowcase/StorefrontMock";
import { DeviceFrame } from "@/components/landing/shared";

interface TabletDeviceProps {
	shopLabel: string;
}

function TabletDevice(prop: TabletDeviceProps) {
	const { shopLabel } = prop;
	return (
		<DeviceFrame className="w-40 rounded-xl">
			<StorefrontMock cols={2} shopLabel={shopLabel} />
		</DeviceFrame>
	);
}

export default TabletDevice;
